import React, { useState, useEffect } from "react";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBIcon,
  MDBContainer,
  MDBCardHeader,
  MDBCardFooter,
  MDBCard,
  MDBCardBody,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBFormInline,
  MDBNavItem,
  MDBNavLink,
  MDBTooltip,
} from "mdbreact";
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from "axios";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from "../components/WarningBox";
import InfoBox from "../components/InfoBox";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { intlFormat, set } from "date-fns";
import MaterialTable, { MTableToolbar } from "material-table";
import { LineWeight } from "@material-ui/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarcode,
  faBoxesPacking,
  faCarOn,
  faLock,
  faMagnifyingGlassArrowRight,
  faPersonWalkingArrowRight,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";
import ViewPackageInclusion from "../Administrator/ViewPackageInclusion";
import ViewServiceInclusion from "../Administrator/ViewServiceInclusions";
import NavTest from "../components/NavTest";
import { height } from "@fortawesome/free-brands-svg-icons/fa42Group";
import AddEditOutsourcedItem from "../Administrator/AddEditOutsourcedItem";
import { useSelector, useDispatch } from "react-redux";
import {
  getTotalSales,
  setDiscountRate,
  setSales,
} from "../features/sales/salesSlice";
import { current } from "@reduxjs/toolkit";

import { Bounce, ToastContainer, toast } from "react-toastify";
import AddEditOutsourcedItemNew from "../Administrator/AddEditOutsourcedItemNew";
// import { selectSales } from "../features/sales/salesSlice";
const AddNewSales = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  let intTotalSales = useSelector((state) => state.sales.value);
  let ticketClosed = useSelector((state) => state.sales.closed);
  const [rTotalSales, setRTotalSales] = useState(0);
  let intTotalDiscountRate = useSelector((state) => state.sales.discountrate);
  let sDiscountType = useSelector((state) => state.sales.discounttype);
  let sDiscountCode = useSelector((state) => state.sales.discountcode);

  const dispatch = useDispatch();

  const serverURL = props.apiServer;
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };

  const bearerPrivate = {
    headers: {
      "Access-Control-Request-Private-Network": "true",
    },
  };

  const [rows, setRows] = useState([]);
  const [intLength, setLength] = useState(0);
  const [isUpdated, setUpdate] = useState(false);

  const [frm, setValues] = useState({
    code: props.code,
    barcode: "",

    parentcode: props.parentcode,
    quantity: 1,
    price: 0,
    dateencoded: new Date(),
    usercode: sessionStorage.getItem("msal.uc"),
    returned: props.returned,
    totalprice: 0,
    itemcode: "",
    item: "",
    sellingprice: 0,
    wholesaleprice: 0,
    amounttendered: 0,
    discountamount: 0,
    discountrate: intTotalDiscountRate,
    discount: sDiscountType,
    discountcode: sDiscountCode,
    amounttendered: 0,
    wholesale: false,
    seniordiscountable: false,
    pwddiscountable: false,
    discountable: false,
    itemcategorycode: "0",
    packagecode: "0",
  });

  const [modalOutsourcedChargesOption, showOutsourcedChargesOption] =
    useState(false);
  const toggleOutsourcedChargesOption = () => {
    centralchargeslist();
    showOutsourcedChargesOption(!modalOutsourcedChargesOption);
  };
  const [itemSaved, setItemSaved] = useState("new");

  const [barcodeInputValue, updateBarcodeInputValue] = useState("");
  const [unitofmeasure, setUnitOfMeasure] = useState("");
  const [disabled, setDisabled] = useState("");

  const [isWholeSale, setWholeSale] = useState(false);

  function numberWithCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const [amtChange, setAmountChange] = useState(0);
  const [amtTendered, setAmountTendered] = useState(0);
  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;
      setValues({ ...frm, [name]: value });
      // setWholeSale(!isWholeSale);
    } else {
      setValues({ ...frm, [name]: value });
      // setUpdate(!isUpdated);
      if (name === "quantity") {
        getTotalPrice(value);
      }
      if (name === "barcode") {
        // console.log(intLength + ' / ' + value.length);

        if (intLength === value.length) {
          getSearchResult(value);
        }
        setLength(value.length);
      }

      if (name === "amounttendered") {
        var s = props.totalSales;
        s = s.replace(/,/g, "");
        setAmountTendered(value);
        // console.log(value);
        // console.log(props.totalSales);
        // console.log(value-s);
        setAmountChange(numberWithCommas((value - s).toFixed(2)));

        // setAmountChange((value-props.totalSales).toFixed(2));
      }
    }
  };

  function barcodeAutoFocus() {
    // document.getElementById("barcode").focus();
  }

  function selectedCharge(rec) {
    updateBarcodeInputValue(rec.code);
    getValuesFromTable(rec);
  }

  function onChangeBarcode(event) {
    updateBarcodeInputValue(event.target.value);
    getSearchResult(event.target.value);
  }

  function onKeyPressBarcode(event) {
    if (event.keyCode === 13) {
      updateBarcodeInputValue(event.target.value);
      getSearchResult(event.target.value);
    }
  }

  function ValidatedDiscount(discountamount) {
    let tmpValue = 0;

    // console.log(Number(props.discountInWeek) + Number(discountamount));
    // console.log(props.discountInWeek);
    // console.log(discountamount);
    // console.log(props.discountLimit);

    if (
      Number(props.discountInWeek) + Number(discountamount) >
      props.discountLimit
    ) {
      console.log("more than 15");
      tmpValue = props.discountLimit - props.discountInWeek;
    } else {
      console.log("ok");
      tmpValue = discountamount;
    }

    return tmpValue;
  }

  function centralchargeslist() {
    Axios.get(props.apiServer + "/centralchargeslist", bearer)
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const getSearchResult = (x) => {
    setItemSaved("");
    Axios.get(serverURL + "/searchitemdetails?acode=" + x, bearer)
      .then((res) => {
        if (res.data !== "empty") {
          if (res.data === "norecord") {
            setValues({
              ...frm,
              barcode: barcodeInputValue,
              itemcode: "No record found",
              item: "No record found",
              sellingprice: 0,
              wholesaleprice: 0,
              totalprice: 0,
              seniordiscountable: false,
              pwddiscountable: false,
              discountable: false,
            });
          } else {
            let tmpSellingPrice = 0;
            let tmpDiscountAmount = 0;
            let tmpBasePrice = 0;
            let tmpVatExemptedPrice = 0;
            let tmpTotalPrice = 0;

            let tmpDiscountRate = 0;

            if (frm.wholesale === true) {
              tmpBasePrice = res.data.wholesaleprice;
            } else {
              tmpBasePrice = res.data.sellingprice;
            }

            tmpVatExemptedPrice = tmpBasePrice / 1.12;

            if (res.data.discountable === false) {
              tmpSellingPrice = tmpBasePrice.toFixed(2);
              tmpDiscountAmount = 0;
              tmpTotalPrice = (tmpSellingPrice * frm.quantity).toFixed(2);
              // tmpTotalPrice=((frm.discountcode==="SC" | frm.discountcode==="PWD") ? ((tmpSellingPrice * frm.quantity)).toFixed(2):(((tmpBasePrice * frm.quantity))).toFixed(2));
            } else {
              if ((frm.discountcode === "SC") | (frm.discountcode === "PWD")) {
                //IF NOT SENIOR or PWD DISCOUNTABLE
                if (
                  (res.data.seniordiscountable === false) |
                  (res.data.pwddiscountable === false)
                ) {
                  tmpSellingPrice = tmpBasePrice.toFixed(2);
                  tmpDiscountAmount = 0;
                } else {
                  //IF SENIOR or PWD DISCOUNTABLE, apply the appropriate discount
                  //BASIC COMMODITIES 5% Discount based on original retail price
                  if (res.data.itemcategorycode === "1") {
                    tmpSellingPrice = tmpBasePrice.toFixed(2);
                    tmpDiscountRate = 0.05;
                    tmpDiscountAmount = (
                      tmpSellingPrice *
                      frm.quantity *
                      tmpDiscountRate
                    ).toFixed(2);

                    tmpDiscountAmount = ValidatedDiscount(tmpDiscountAmount);
                  } else {
                    tmpSellingPrice = tmpVatExemptedPrice.toFixed(2);
                    tmpDiscountRate = 0.2;
                    tmpDiscountAmount = (
                      tmpSellingPrice *
                      frm.quantity *
                      tmpDiscountRate
                    ).toFixed(2);
                    tmpDiscountAmount = ValidatedDiscount(tmpDiscountAmount);
                  }
                }
              } else {
                tmpSellingPrice = tmpBasePrice.toFixed(2);
                tmpDiscountRate = frm.discountrate;
                tmpDiscountAmount = (
                  tmpSellingPrice *
                  frm.quantity *
                  tmpDiscountRate
                ).toFixed(2);
              }

              // console.log('first:' + tmpDiscountAmount);

              // tmpTotalPrice=((tmpSellingPrice * frm.quantity) * (1-tmpDiscountRate)).toFixed(2);
              tmpTotalPrice = (
                tmpSellingPrice * frm.quantity -
                tmpDiscountAmount
              ).toFixed(2);
            }

            setValues({
              ...frm,

              barcode: barcodeInputValue,
              itemcode: res.data.code,
              item: res.data.description,
              sellingprice: tmpSellingPrice,
              totalprice: tmpTotalPrice,
              discountamount: tmpDiscountAmount,
              parentcode: props.parentcode,
            });

            setItemSaved(res.data.code);
          }
          setItemSaved(res.data.code);
        } else {
          //  ClearFields();
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const getValuesFromTable = (x) => {
    let tmpSellingPrice = 0;
    let tmpDiscountAmount = 0;
    let tmpBasePrice = 0;
    let tmpVatExemptedPrice = 0;
    let tmpTotalPrice = 0;

    let tmpDiscountRate = 0;

    if (frm.wholesale === true) {
      tmpBasePrice = x.wholesaleprice;
    } else {
      tmpBasePrice = x.sellingprice;
    }

    // tmpVatExemptedPrice = tmpBasePrice / 1.12;

    // console.log(x.discountable === true ? "DISCOUNTABLE" : "NOT DISCOUNTABLE");

    // console.log(
    //   x.seniordiscountable === true ? " SC DISCOUNTABLE" : "NOT SC DISCOUNTABLE"
    // );
    // console.log(
    //   x.pwddiscountable === true ? " PWD DISCOUNTABLE" : "NOT PWD DISCOUNTABLE"
    // );

    // if (x.discountable === false) {
    //   tmpSellingPrice = tmpBasePrice.toFixed(2);
    //   tmpDiscountAmount = 0;
    //   tmpTotalPrice = (tmpSellingPrice * frm.quantity).toFixed(2);
    // } else {
    //   if ((frm.discountcode === "SC") | (frm.discountcode === "PWD")) {
    //     //IF NOT SENIOR or PWD DISCOUNTABLE
    //     if ((x.seniordiscountable === false) | (x.pwddiscountable === false)) {
    //       tmpSellingPrice = tmpBasePrice.toFixed(2);
    //       tmpDiscountAmount = 0;
    //     } else {
    //       //IF SENIOR or PWD DISCOUNTABLE, apply the appropriate discount
    //       //BASIC COMMODITIES 5% Discount based on original retail price
    //       if (x.itemcategorycode === "1") {
    //         tmpSellingPrice = tmpBasePrice.toFixed(2);
    //         tmpDiscountRate = 0.05;
    //         tmpDiscountAmount = (
    //           tmpSellingPrice *
    //           frm.quantity *
    //           tmpDiscountRate
    //         ).toFixed(2);

    //         tmpDiscountAmount = ValidatedDiscount(tmpDiscountAmount);
    //       } else {
    //         tmpSellingPrice = tmpVatExemptedPrice.toFixed(2);
    //         tmpDiscountRate = 0.2;
    //         tmpDiscountAmount = (
    //           tmpSellingPrice *
    //           frm.quantity *
    //           tmpDiscountRate
    //         ).toFixed(2);
    //         tmpDiscountAmount = ValidatedDiscount(tmpDiscountAmount);
    //       }
    //     }
    //   } else {
    //     //OTHER DISCOUNTS
    //     console.log("OTHER DISCOUNTS");
    //     tmpSellingPrice = tmpBasePrice.toFixed(2);
    //     tmpDiscountRate = intTotalDiscountRate;
    //     tmpDiscountAmount = (
    //       tmpSellingPrice *
    //       frm.quantity *
    //       tmpDiscountRate
    //     ).toFixed(2);
    //   }

    //   tmpTotalPrice = (
    //     tmpSellingPrice * frm.quantity -
    //     tmpDiscountAmount
    //   ).toFixed(2);
    // }

    //disregard real time discounts
    //discounts will be processed on the backend
    tmpSellingPrice = tmpBasePrice.toFixed(2);
    tmpDiscountAmount = 0;
    tmpTotalPrice = (tmpSellingPrice * frm.quantity).toFixed(2);
    setValues({
      ...frm,

      barcode: x.barcode,
      itemcode: x.code,
      item: x.description,
      sellingprice: tmpSellingPrice,
      totalprice: tmpTotalPrice,
      discountamount: 0,
      parentcode: props.parentcode,
      itemcategorycode: x.itemcategorycode,
      packagecode: x.packagecode,
    });

    setItemSaved(x.code);
  };

  const TitleBar = () => {
    return (
      <React.Fragment>
        <MDBInput
          value={frm.quantity}
          id="quantity"
          label="Quantity"
          onChange={updateField}
          // className={disabled}
        ></MDBInput>
        {/* <h4
          style={{
            fontFamily: "Roboto",
            fontWeight: "800",
            fontSize: "1em",
            padding: "0",
          }}
          className="h4-responsive pt-4 font-weight-bold"
        >
          Add Charges Here
        </h4>

        <p className="small">{props.description}</p> */}
      </React.Fragment>
    );
  };

  const searchItem = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      return;
    } else {
      setValues({ ...frm, [name]: value });

      getSearchResult(value);
    }
  };

  const getTotalPrice = (x) => {
    // console.log(x);
    setValues({
      ...frm,

      quantity: x,
      totalprice: frm.sellingprice * x * (1 - props.discountrate),
    });
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
  };

  const getDateValue = (dtPickerName) => (actualValue) => {
    setValues({ ...frm, [dtPickerName]: actualValue });
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    savesales();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const [modalInfo, showInfoBox] = useState(false);

  const toggleInfoBox = () => {
    showInfoBox(!modalInfo);
  };

  const ClearFields = () => {
    setValues({
      ...frm,

      code: props.code,
      barcode: "",

      parentcode: props.parentcode,
      quantity: 1,
      price: 0,
      dateencoded: new Date(),
      usercode: sessionStorage.getItem("msal.uc"),
      returned: props.returned,
      totalprice: 0,
      itemcode: "",
      item: "",
      sellingprice: 0,

      discountamount: 0,
      discountrate: props.discountrate,
      discount: props.discounttype,
      discountcode: props.discountcode,
    });
  };

  const PrintInvoice = () => {
    const data = frm;
    if (props.code === null) {
      return;
    }
    Axios.post(
      props.apiServerHybrid +
        "/Print/ORPrint?reporttype=invoice&code=" +
        props.parentcode +
        "&uc=" +
        sessionStorage.getItem("msal.uc") +
        "&at=" +
        amtTendered,

      bearerPrivate
    )
      .then((res) => {
        if (res.data.status === "1") {
          updateBarcodeInputValue(res.data.barcode);

          ClearFields();
          updateBarcodeInputValue("");
          setIfPrintedAlready(1);
          checkIfPrintedAlready();
        } else {
          console.log(res.data.message);
          //  alert('Please use Google Chrome when printing invoices to secure your transaction.');
        }
      })
      .catch((error) => {
        alert(error);
      });

    // <a href={props.apiServerHybrid + "/Print/ORPrint?reporttype=invoice&code=" + rowData.code} rel="noopener noreferrer" target="_blank" ><MDBIcon icon="external-link-alt" /></a>
  };

  const savesales = () => {
    //COMMENTED TO ALLOW FREE ITEMS
    // console.log(frm);
    // if (frm.totalprice <= 0) {
    //   return;
    // }

    const data = frm;

    Axios.post(props.apiServer + "/savesales", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          // setValues({...frm, code : res.data.code});
          // updateBarcodeInputValue(res.data.barcode);

          ClearFields();
          updateBarcodeInputValue("");
          setItemSaved("new");
          props.refreshGrid(res.data.message);
        } else {
          setErrorMessage("Invalid entry!");
          toggleWarningBox(errorMessage);
          // alert('error');
        }
      })
      .catch((error) => {
        // alert('error');
        setErrorMessage(error);
        toggleWarningBox(errorMessage);
      });
  };

  const opencpd = () => {
    if (frm.totalprice <= 0) {
      return;
    }

    const data = frm;

    Axios.get(
      props.apiServerPOS +
        "/opencpd?brand=" +
        frm.item.substring(0, 6) +
        "&amount=" +
        frm.sellingprice +
        "&total=" +
        props.totalSales
    )
      .then((res) => {
        if (res.data.status === "1") {
        } else {
          console.log("CPD Connection Failed!");
        }
      })
      .catch((error) => {
        console.log("CPD Connection Failed!");
      });
  };

  const [isPrintedAlready, setIfPrintedAlready] = useState(0);

  function checkIfPrintedAlready() {
    Axios.get(
      props.apiServer + "/getinvoicestatus?par=" + props.parentcode,
      bearer
    )
      .then((res) => {
        setIfPrintedAlready(0);
        setIfPrintedAlready(res.data[0].isprinted);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [showPreloader, setPreloader] = useState("normal");

  const [modalDelete, showDeleteBox] = useState(false);

  const deleteRecord = () => {
    if (props.code === "new") {
      setErrorMessage("Please select a record!");
      toggleWarningBox();

      return;
    }

    showDeleteBox(!modalDelete);
  };

  /* eslint-disable */

  const [totalSales, setTotalSales] = useState(0);

  function checkTotalSales() {
    Axios.get(
      props.apiServer + "/gettotalsales?par=" + props.parentcode,
      bearer
    )
      .then((res) => {
        setTotalSales(0);
        setTotalSales(res.data[0].totalprice);
      })

      .catch((error) => {
        console.log(error);
      });
  }
  const [totalUpdated, setTotalUpdated] = useState(false);

  useMountEffect(centralchargeslist);

  useEffect(() => {
    setAmountChange(0);

    if (frm.itemcode !== "") {
      savesales();
    } else {
    }

    checkIfPrintedAlready();
    // props.checkTotalSales();
    // checkTotalSales();
    // dispatch(setSales(totalSales));

    props.getdiscountinweek();
  }, [itemSaved, frm.code]);

  useEffect(() => {
    setTotalSales(intTotalSales);
  }, [intTotalSales]);

  return (
    <React.Fragment>
      <MDBNavbar
        className="cloudy-knoxville-gradient w-75 pt-0"
        color="primary"
        expand="md"
        fixed="top"
        scrolling
        fluid
        style={{ height: "75px" }}
      >
        <MDBContainer fluid className="pt-0 mt-0">
          <MDBRow className="float-right">
            <MDBCol md="12">
              <MDBFormInline>
                <span
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: "400",
                  }}
                  className="black-text"
                >
                  {" "}
                  Amount Tendered:
                </span>

                <MDBInput
                  value={frm.amounttendered}
                  id="amounttendered"
                  labelClass="p-0 m-0 hidden"
                  onChange={updateField}
                  className="font-weight-bold black-text pt-0 mt-0 text-center"
                  style={{
                    fontSize: "35px",
                    width: "150px",
                  }}
                ></MDBInput>
                <span
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: "400",
                  }}
                  className="blue-text pb-0 mb-0 pl-5"
                >
                  {" "}
                  Change:
                </span>

                <span
                  className="font-weight-bold black-text pl-5"
                  style={{
                    fontFamily: "Arial Black",
                    fontWeight: "240",
                  }}
                >
                  P&nbsp;{amtChange}
                </span>
                <span
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: "400",
                  }}
                  className="h3-responsive font-weight-bold red-text pb-0 mb-0 pl-5"
                >
                  {" "}
                  Amount to Pay:
                </span>
                <span
                  className="h3-responsive font-weight-bold black-text pl-5"
                  style={{
                    fontFamily: "Arial Black",
                    fontWeight: "400",
                  }}
                >
                  <strong>P&nbsp;{totalSales}</strong>
                </span>
              </MDBFormInline>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </MDBNavbar>

      <form className="needs-validation" onSubmit={submitHandler} noValidate>
        <MDBRow hidden>
          <MDBInput value={frm.code} id="code" label="Code">
            <div className="invalid-feedback">This field is required!</div>
            <div className="valid-feedback"></div>
          </MDBInput>
        </MDBRow>
        {ticketClosed === true ? (
          <>
            <MDBRow>
              <MDBCol md="12" className="text-left">
                <h1 className="font-weight-bold h1-responsive  brown-text">
                  <FontAwesomeIcon
                    icon={faLock}
                    size="2x"
                    className="brown-text"
                  >
                    {" "}
                  </FontAwesomeIcon>
                  &nbsp; TICKET RELEASED
                </h1>
                <br />
              </MDBCol>
            </MDBRow>
          </>
        ) : (
          <>
            <MDBRow>
              <MDBCol md="12" className="text-left">
                <h1 className="font-weight-bold h1-responsive blue-text">
                  <FontAwesomeIcon
                    icon={faCarOn}
                    size="2x"
                    className="blue-text"
                  >
                    {" "}
                  </FontAwesomeIcon>
                  ACTIVE TICKET
                </h1>
                <br />
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="6">
                <span
                  style={{
                    fontFamily: "Montserrat",
                    fontWeight: "400",
                  }}
                  className="h5-responsive black-text ml-1"
                >
                  {" "}
                  Search Charges Here:
                </span>{" "}
              </MDBCol>
              <MDBCol md="6" className="text-right">
                <MDBTooltip placement="left">
                  <MDBBtn
                    className="cloudy-knoxville-gradient"
                    size="sm"
                    onClick={toggleOutsourcedChargesOption}
                  >
                    <FontAwesomeIcon
                      icon={faMagnifyingGlassArrowRight}
                      size="2x"
                      className="red-text"
                    />
                  </MDBBtn>
                  <div>Add Outsourced Item</div>
                </MDBTooltip>
              </MDBCol>
            </MDBRow>

            <MDBRow hidden>
              <MDBCol md="2" className="text-left">
                <MDBInput
                  value={frm.quantity}
                  id="quantity"
                  label="Quantity"
                  onChange={updateField}
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
              <MDBCol md="8" className="text-left">
                <MDBInput
                  autoFocus={true}
                  autoComplete="off"
                  value={barcodeInputValue}
                  onChange={onChangeBarcode}
                  id="barcode"
                  className="SearchInput"
                  onKeyDown={onKeyPressBarcode}
                  onBlur={barcodeAutoFocus}
                >
                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>
                </MDBInput>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="12">
                <MaterialTable
                  title={<TitleBar></TitleBar>}
                  components={{
                    Toolbar: (props) => (
                      <div>
                        <MTableToolbar {...props} />
                      </div>
                    ),
                  }}
                  actions={[
                    {
                      icon: () => <MDBIcon icon="plus" className="blue-text" />,
                      tooltip: "Add to Current Charges",
                      onClick: (event, rowData) => selectedCharge(rowData),
                    },
                  ]}
                  columns={[
                    {
                      title: "Barcode",
                      field: "barcode",
                      cellStyle: {
                        width: 250,
                        maxWidth: 250,
                      },
                      headerStyle: {
                        width: 250,
                        maxWidth: 250,
                      },
                      hidden: true,
                    },
                    {
                      title: "Item Description",
                      field: "description",
                      render: (rowData) => (
                        <>
                          <span className="small font-weight-bold">
                            <small>
                              <strong>{rowData.descriptiondetailed}</strong>
                            </small>
                          </span>
                          {Boolean(rowData.outsourced) === false ? (
                            ""
                          ) : (
                            <>
                              <br />
                              <small>
                                <span className="green-text font-weight-bold">
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={faMagnifyingGlassArrowRight}
                                    size="1x"
                                  />
                                  &nbsp; OUTSOURCED
                                </span>
                              </small>
                            </>
                          )}
                        </>
                      ),
                    },
                    { title: "Selling Price", field: "sellingprice" },

                    {
                      title: "Wholesale Price",
                      field: "wholesaleprice",
                      hidden: true,
                    },
                    {
                      title: "Charge Type",
                      field: "ChargeType",
                      lookup: {
                        "INVENTORY ITEM": "INVENTORY ITEM",
                        SERVICE: "SERVICE",
                        PACKAGE: "PACKAGE",
                      },
                    },
                    { title: "Item Code", field: "code", hidden: true },

                    {
                      title: "Item Code",
                      field: "descriptiondetailed",
                      hidden: true,
                      searchable: true,
                    },
                  ]}
                  detailPanel={[
                    {
                      icon: () => (
                        // <MDBIcon icon="list" className="blue-text" />
                        <FontAwesomeIcon
                          icon={faBoxesPacking}
                          className="purple-text"
                        />
                      ),
                      openIcon: () => (
                        <MDBIcon
                          icon="chevron-circle-down"
                          className="red-text"
                        />
                      ),
                      tooltip: "Inclusions",
                      render: (rowData) => {
                        return (
                          <React.Fragment>
                            <MDBContainer className="ml-0 p-0" fluid>
                              <MDBCardHeader className="cloudy-knoxville-gradient">
                                <span className="font-weight-bold">
                                  {" "}
                                  Inclusions
                                </span>
                              </MDBCardHeader>

                              {rowData.ChargeType === "PACKAGE" ? (
                                <>
                                  <ViewPackageInclusion
                                    deployURL={props.deployURL}
                                    apiServer={props.apiServer}
                                    apiServerHybrid={props.apiServerHybrid}
                                    toggleModal={props.toggleAddEdit}
                                    refreshGrid={props.refreshGrid}
                                    parentcode={rowData.packagecode}
                                  />
                                </>
                              ) : (
                                <>
                                  {rowData.ChargeType === "SERVICE" ? (
                                    <>
                                      {" "}
                                      <ViewServiceInclusion
                                        deployURL={props.deployURL}
                                        apiServer={props.apiServer}
                                        apiServerHybrid={props.apiServerHybrid}
                                        toggleModal={props.toggleAddEdit}
                                        refreshGrid={props.refreshGrid}
                                        parentcode={rowData.packagecode}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      {" "}
                                      <h1
                                        className="h1-responsive red-text p-3"
                                        style={{
                                          fontFamily: "Montserrat",
                                          fontWeight: "400",
                                        }}
                                      >
                                        <span className="red-text">
                                          <FontAwesomeIcon icon={faLock} />
                                        </span>
                                        &nbsp;Not Applicable
                                      </h1>
                                    </>
                                  )}
                                </>
                              )}

                              <MDBCardFooter></MDBCardFooter>
                            </MDBContainer>
                          </React.Fragment>
                        );
                      },
                    },
                  ]}
                  data={rows}
                  options={{
                    search: true,

                    filtering: true,

                    cellStyle: {
                      width: "100%",
                      paddingLeft: "0px",
                    },
                    pageSize: 75,
                    pageSizeOptions: [75, 100, 250],
                  }}
                />
              </MDBCol>
            </MDBRow>
          </>
        )}

        <MDBRow hidden>
          <MDBCol md="12" className="text-left">
            <MDBInput
              autoFocus
              value={frm.itemcode}
              id="itemcode"
              label="Item Code"
              type="textarea"
              onChange={updateField}
              className={disabled}
            >
              <div className="invalid-feedback">This field is required!</div>
              <div className="valid-feedback"></div>
            </MDBInput>
          </MDBCol>
        </MDBRow>

        <MDBRow hidden>
          <MDBInput value={frm.parentcode} id="parentcode" label="parentcode">
            <div className="invalid-feedback">This field is required!</div>
            <div className="valid-feedback"></div>
          </MDBInput>
        </MDBRow>

        {/* //old */}
      </form>

      <MDBModal
        backdrop={false}
        isOpen={modalOutsourcedChargesOption}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBModalHeader
          toggle={toggleOutsourcedChargesOption}
          className="cloudy-knoxville-gradient"
        >
          <span className="h6-responsive brown-text font-weight-bold">
            Add Outsourced Charge
          </span>
        </MDBModalHeader>
        <MDBModalBody>
          <AddEditOutsourcedItemNew
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            code="new"
            parentcode={props.parentcode}
            apiServerHybrid={props.apiServerHybrid}
            apiServerPOS={props.apiServerPOS}
            toggleModal={toggleOutsourcedChargesOption}
            refreshGrid={props.refreshGrid}
          ></AddEditOutsourcedItemNew>
          {/* <AddEditOutsourcedItem
            deployURL={props.deployURL}
            apiServer={props.apiServer}
            apiServerHybrid={props.apiServerHybrid}
            quickadd={"yes"}
            toggleModal2={toggleOutsourcedChargesOption}
            itemcode={""}
           
          /> */}
        </MDBModalBody>
      </MDBModal>
      <InfoBox
        errorMessage={errorMessage}
        isOpen={modalInfo}
        toggleModal={toggleInfoBox}
      />
      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      ></ToastContainer>
    </React.Fragment>
  );
};
export default AddNewSales;
